import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';

import SearchBar from './SearchBar';
import { defaultStateForMapStateToProps } from '../../../utils/redux';
import { selectAllowedPages } from '../../../reducers/user-reducer';

const defaultState = {
  allowedPages: selectAllowedPages
};

const mapStateToProps = defaultStateForMapStateToProps(defaultState);

export default withRouter(connect(mapStateToProps)(SearchBar));
